'use client'

import { InfoCircle24 } from '@vinted/monochrome-icons'
import { Card, Cell, Spacer, Text, Icon } from '@vinted/web-ui'

import BadgeProgress from '../BadgeProgress/BadgeProgress'

type Props = {
  titleText: string
  bodyText: string
  iconProps: { icon: ComponentProps<typeof Icon>['name'] | null; progress: number }
  onClick: () => void
}

const BadgeBanner = ({ titleText, bodyText, iconProps, onClick }: Props) => {
  const { progress, icon } = iconProps

  return (
    <div className="u-fill-width u-fill-child-component">
      <Card>
        <div className="u-overflow-hidden u-fill-height u-fill-child-component">
          <Cell type={Cell.Type.Navigating} onClick={onClick} testId="badge-banner">
            <div className="u-flexbox u-justify-content-between">
              <div className="u-flexbox">
                <div className="u-flexbox u-align-self-center">
                  {icon && (
                    <BadgeProgress
                      icon={
                        <div>
                          <Icon
                            name={icon}
                            color={Icon.Color.Primary}
                            display={Icon.Display.Block}
                          />
                        </div>
                      }
                      progress={progress}
                    />
                  )}
                </div>
                <Spacer size={Spacer.Size.Regular} orientation={Spacer.Orientation.Vertical} />
                <div className="u-align-self-center">
                  <Text as="h2" text={titleText} type={Text.Type.Title} />
                  <br />
                  <Text as="span" text={bodyText} />
                </div>
              </div>
              <Spacer size={Spacer.Size.Regular} orientation={Spacer.Orientation.Vertical} />
              <div className="u-align-self-center">
                <Icon name={InfoCircle24} color={Icon.Color.GreyscaleLevel2} />
              </div>
            </div>
          </Cell>
        </div>
      </Card>
    </div>
  )
}

export default BadgeBanner
